import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import AddApp from '@/assets/icons/AddApp';
import Button from '@/components/Buttons/Button';
import { DashboardStep } from '@/features/Dashboard/constants/DashboardStep';
import { DASHBOARD_ACTION_BUTTON_WIDTH } from '@/features/Dashboard/constants/style';
import { useDashboardEditLockContext } from '@/features/Dashboard/context/DashboardEditLockContext';
import { ButtonsContainer } from '@/features/Dashboard/drawer/components/ButtonsContainer';
import { DrawerStep, useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';

export const DashboardActionButtons = ({
  setStep,
  children
}: {
  setStep: (step: DashboardStep) => void;
  children?: React.ReactNode;
}) => {
  const { setDrawerStep } = useDrawerSteps();
  const { requestEditLock } = useDashboardEditLockContext();

  const handleAddApp = () => {
    requestEditLock(() => {
      setDrawerStep(DrawerStep.SelectApp);
    });
  };

  return (
    <ButtonsContainer>
      {children}
      <Button
        color='secondary'
        size='large'
        startIcon={<EditOutlinedIcon />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={() => {
          setStep(DashboardStep.Edit);
        }}
      >
        Edit
      </Button>
      <Button
        color='secondary'
        size='large'
        startIcon={<AddApp fill='#F8F8F8' />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={handleAddApp}
      >
        Add app
      </Button>
    </ButtonsContainer>
  );
};
